import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SetupFee } from '../../models/activate-link.model';

@Component({
  selector: 'gdp-activation-link-setup-fee',
  templateUrl: './activation-link-setup-fee.component.html',
  styleUrls: ['./activation-link-setup-fee.component.scss']
})
export class ActivationLinkSetupFeeComponent {
  @Input() isSelected: boolean = false;
  @Input() setupFee: SetupFee = null;

  @Output() amountChange: EventEmitter<number> = new EventEmitter();

  amount: number = 0;

  ngOnChanges(): void {
    if (this.setupFee) {
      this.amount = this.setupFee.amount;
    }
  }

  onAmountChange(value: number): void {
    if (value !== null && value !== undefined && !isNaN(value) && value >= 0) {
      this.amount = value;
      this.amountChange.emit(value);
    }
  }

  onBlur(input: HTMLInputElement): void {
    if (this.amount === null || this.amount === undefined || isNaN(this.amount) || this.amount < 0) {
      this.amount = 0;
    }
    input.value = this.amount.toString();
    this.amountChange.emit(this.amount);
  }
}
